import FormError from "@casino/legacyUi/form/FormError";
import { FormItem } from "@casino/legacyUi/form/FormItem";
import type { RefObject } from "react";
import {
  type Control,
  Controller,
  type FieldValues,
  type Path,
  type RegisterOptions,
} from "react-hook-form";
import type Reaptcha from "reaptcha";
import ReCAPTCHA from "./ReCAPTCHA";

type Props<T extends FieldValues> = {
  name: Path<T>;
  control: Control<T>;
  error?: string;
  rules?: RegisterOptions;
  ref?: RefObject<Reaptcha>;
};

const FormReCAPTCHA = <T extends FieldValues>({
  name,
  control,
  rules,
  error,
  ref,
}: Props<T>) => (
  <Controller
    control={control}
    name={name}
    rules={rules}
    render={({ field }) => (
      <FormItem data-testid="recaptcha">
        <ReCAPTCHA onVerify={field?.onChange} recaptchaRef={ref} />
        <FormError message={error} />
      </FormItem>
    )}
  />
);

export default FormReCAPTCHA;
